import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      closeButton={true}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-foreground group-[.toaster]:text-background group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:pr-8",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "group-[.toast]:absolute group-[.toast]:right-2 group-[.toast]:top-1/2 group-[.toast]:-translate-y-1/2 group-[.toast]:left-auto group-[.toast]:transform group-[.toast]:border-none group-[.toast]:bg-transparent group-[.toast]:text-background group-[.toast]:hover:text-background/80 group-[.toast]:opacity-100",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
